/**
 * Fades out the first-paint loader that index.html bakes into the page.
 *
 * main.tsx calls this two animation frames after mount, so the freshly rendered
 * shell has painted before the loader goes (no flash to blank).
 */
const LOADER_FADE_MS = 300;

export function dismissAppLoader(): void {
  const loader = document.querySelector("#app-loader");
  if (!loader) {
    return;
  }
  loader.classList.add("app-loader--hidden");
  setTimeout(() => {
    loader.remove();
  }, LOADER_FADE_MS);
}
